import { createAction } from '~reduxHelpers';
import * as api from '~services/api'; // eslint-disable-line

export const basePath = '/palvelut/projektit';

export const setProjectOrderLink = createAction('SET_PROJECT_ORDER_LINK');

const initialState = {
  projectOrderLink: null,
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'SET_PROJECT_ORDER_LINK':
      return { ...state, projectOrderLink: action.payload };
    default:
      return state;
  }
}

export const getTemplates = () => api.get('projects/templates');

export const getTemplate = id => api.get(`projects/templates/${id}`);

export const getProjects = () => api.get(`projects/`);

/*
{
  "templateId":1,
  "title":"Some project",
  "tasks":[
    {
      "title":"Free task"
    },
    {
      "title":"Transit task",
      "formId": 7
    }
  ]
}
*/
export const createProject = projectData => api.post(`projects/`, projectData);

export const createProjectFromTemplate = (templateId, projectData) =>
  api.post(`projects/?templateId=${templateId}`, projectData);

export const getProject = projectId => api.get(`projects/${projectId}`);

export const deleteProject = projectId => api.del(`projects/${projectId}`);

export const updateProject = (projectId, body) =>
  api.put(`projects/${projectId}`, body);

export const getHistory = projectId =>
  api.get(`projects/${projectId}/notifications`);

/*
{
  "title":"Transit task",
  "formId": 7
}
*/
export const addProjectTask = (projectId, taskData) =>
  api.post(`projects/${projectId}/tasks/`, taskData);
/*
{
  "id": "555",
  "title":"Transit task",
  "formId": 7,
  "orderId": 1234
}
*/
export const modifyProjectTask = (projectId, taskId, taskData) =>
  api.put(`projects/${projectId}/tasks/${taskId}`, taskData);

export const deleteProjectTask = (projectId, taskId) =>
  api.del(`projects/${projectId}/tasks/${taskId}`);

// You can update just a single field if desired
export const updateProjectField = (projectId, fieldData) =>
  api.put(`projects/${projectId}`, fieldData);

// Participants

export const addParticipant = (projectId, userId) =>
  api.post(`projects/${projectId}/participants/?userId=${userId}`);

export const removeParticipant = (projectId, userId) =>
  api.del(`projects/${projectId}/participants/${userId}`);

export const addComment = (projectId, taskId, body) =>
  api.post(`projects/${projectId}/tasks/${taskId}/comments`, body);

export default reducer;
